import { FormArray, FormControl } from '@angular/forms';

export type InsuranceAddFormControls = {
  name: FormControl<string | null>;
  street: FormControl<string | null>;
  street2: FormControl<string | null>;
  city: FormControl<string | null>;
  zip: FormControl<number | null>;
  state: FormControl<string | null>;
  payer_id: FormControl<string | null>;
  uses_supervisor_as_provider: FormControl<boolean>;
  uses_is_telehealth: FormControl<boolean>;
  daily_limit_hours: FormControl<number | null>;
  notes: FormArray;
};

export type InsuranceEditFormControls = {
  name: FormControl<string | null>;
  street: FormControl<string | null>;
  street2: FormControl<string | null>;
  city: FormControl<string | null>;
  zip: FormControl<number | null>;
  state: FormControl<string | null>;
  payer_id: FormControl<string | null>;
  uses_supervisor_as_provider: FormControl<boolean>;
  uses_is_telehealth: FormControl<boolean>;
  daily_limit_hours: FormControl<number | null>;
  notes: FormArray;
  pos_allowed_to_cg: FormArray<FormControl<string>>;
  pos_allowed_to_tt: FormArray<FormControl<string>>;
  extra_pos_for_bcba: FormArray<FormControl<string>>;
};

export const INSURANCE_PRODUCTS = [
  'tanf',
  'SSI Non Dual MMA',
  'Foster Care',
  'CMS Title 21',
  'CMS Title 19',
] as const;

export type InsuranceProduct =
  (typeof INSURANCE_PRODUCT_OPTIONS)[number]['value'];

export const INSURANCE_PRODUCT_OPTIONS = [
  { value: 'tanf', label: 'TANF' },
  { value: 'SSI Non Dual MMA', label: 'SSI Non Dual MMA' },
  { value: 'Foster Care', label: 'Foster Care' },
  { value: 'CMS Title 21', label: 'CMS Title 21' },
  { value: 'CMS Title 19', label: 'CMS Title 19' },
] as const;